import GE1 from "../images/1.jpeg";
import GE2 from "../images/2.jpeg";
import GE3 from "../images/3.jpg";

// import GE4 from "../images/4.jpg";
// import GE5 from "../images/5.jpg";
// import GE6 from "../images/6.jpg";
// import GE7 from "../images/7.jpg";
// import GE8 from "../images/8.jpg";
// import GE9 from "../images/9.jpg";
// import GE10 from "../images/10.jpg";
// import GE11 from "../images/11.jpg";
// import GE12 from "../images/12.jpg";
// import GE13 from "../images/13.jpg";
// import GE14 from "../images/14.jpg";
import GE15 from "../images/15.jpg";

const carouselData = [
  { image: GE1, text: "Welcome to GESS Website" },
  { image: GE2, text: "Explore Our Resources" },
  { image: GE3, text: "Join Our Community" },
  // { image: GE4, text: "Learn with Us" },
  // { image: GE5, text: "Discover New Opportunities" },
  // { image: GE6, text: "GESS - Your Engineering Hub" },
  // { image: GE7, text: "Innovation Starts Here" },
  // { image: GE8, text: "Building a Better Future" },
  // { image: GE9, text: "Geology and Engineering Combined" },
  // { image: GE10, text: "Explore, Learn, Grow" },
  // { image: GE11, text: "Join Our Events" },
  // { image: GE12, text: "Student Success Stories" },
  // { image: GE13, text: "Knowledge is Power" },
  // { image: GE14, text: "Shape the World with GESS" },
  { image: GE15, text: "Welcome to the Future" },
];

export default carouselData;
